export enum ServiceNames {
  helpArticle = "helpArticle"
}
